module.exports = new Promise((resolve) => {
    const baseUrl = (window.RUNTIME && window.RUNTIME['VITALSIGNS_REMOTE_URL']) || '';

    if (!baseUrl) {
      console.error('Missing vital signs remote URL');
      return resolve({
        get: () => Promise.reject(new Error('Missing vital signs remote URL')),
        init: () => {}
      });
    }

    const remoteUrl = (() => {
      const separator = baseUrl.includes('?') ? '&' : '?';
      return `${baseUrl}${separator}t=${Date.now()}`;
    })();

    if (window['vitalsignsApp']) {
      const existingContainer = window['vitalsignsApp'];
      return resolve({
        get: (request) => existingContainer.get(request),
        init: (arg) => {
          try {
            return existingContainer.init(arg);
          } catch (_) {}
        }
      });
    }

    const existingScript = document.querySelector('script[data-mf-remote="vitalsignsApp"]');
    if (existingScript) {
      existingScript.addEventListener('load', () => {
        const container = window['vitalsignsApp'];
        if (!container) {
          return resolve({
            get: () => Promise.reject(new Error('vitalsignsApp not found')),
            init: () => {}
          });
        }

        resolve({
          get: (request) => container.get(request),
          init: (arg) => {
            try {
              return container.init(arg);
            } catch (_) {}
          }
        });
      });

      existingScript.addEventListener('error', () => {
        resolve({
          get: () => Promise.reject(new Error('Failed loading vital signs remote')),
          init: () => {}
        });
      });

      return;
    }

    const el = document.createElement('script');
    el.src = remoteUrl;
    el.type = 'text/javascript';
    el.async = true;
    el.crossOrigin = 'anonymous';
    el.dataset.mfRemote = 'vitalsignsApp';

    el.onload = () => {
      const container = window['vitalsignsApp'];
      if (!container) {
        console.error('Remote container "vitalsignsApp" not found on window');
        return resolve({
          get: () => Promise.reject(new Error('vitalsignsApp not found')),
          init: () => {}
        });
      }

      resolve({
        get: (request) => container.get(request),
        init: (arg) => {
          try {
            return container.init(arg);
          } catch (_) {}
        }
      });
    };

    el.onerror = () => {
      console.error('Failed to load remoteEntry:', remoteUrl);
      el.remove();
      resolve({
        get: () => Promise.reject(new Error('Failed loading vital signs remote')),
        init: () => {}
      });
    };

    document.head.appendChild(el);
  })
;